import {
  Button,
  IconValidationValid,
  Text,
} from '@adc/parallax-component-library';
import { Dialog } from '@tamagui/dialog';

import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

import { ModalOverlay } from '../ModalOverlay';

type AccountActivatedModalProps = {
  testID: string;
};

export const AccountActivatedModal = ({
  testID,
}: AccountActivatedModalProps) => {
  const { closeModal } = useModal();

  const onClose = () => {
    closeModal('AccountActivated');
  };

  const onOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={onOpenChange} modal>
      <Dialog.Portal>
        <ModalOverlay />

        <Dialog.Content
          testID={testID}
          key="content"
          elevate
          animateOnly={['transform', 'opacity']}
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ x: 0, y: 20, opacity: 0 }}
          exitStyle={{ x: 0, y: 10, opacity: 0, scale: 0.95 }}
          padding="$6"
          borderWidth="$0"
          maxWidth={800}
          width="100%"
          borderRadius="$1.5"
          backgroundColor="$surface.background"
          alignItems="center"
        >
          <IconValidationValid
            size="XL"
            color="$support.positive.default"
            testID={buildTestId({
              testID,
              suffix: 'checkmark',
            })}
          />
          <Text
            type="$h3.medium"
            testID={buildTestId({
              testID,
              suffix: 'title',
            })}
          >
            Account Activated
          </Text>

          <Text
            type="$bodySmall.default"
            color="$text.60"
            paddingTop="$3"
            testID={buildTestId({
              testID,
              suffix: 'summary',
            })}
          >
            Welcome to LactateView
          </Text>

          <Button
            variant="primary"
            label="Done"
            onPress={onClose}
            marginTop="$6"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'done'],
            })}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
